import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import type { JSX } from 'react';

import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Card from '@/ui/components/Card';

// const dataExample = {
//   mission: {
//     goal: 1,
//     score: 1,
//     title: 'Open App 1 time(s)',
//     status: 'Finished',
//     claimedBy: null,
//     recurrency: 'Daily',
//     createdAtDatetime: '2023-07-20T02:00:00.682+00:00',
//     finishedAtDatetime: '2023-07-20T12:08:49.259+00:00'
//   },
//   backfill: false,
//   finished_at_datetime: '2023-07-20T12:08:49.259+00:00'
// };

const MissionEvent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { actor, data, timestamp } = activityLog;

  return (
    <div>
      <Card>
        <TimelineHeader
          icon={faCheckDouble}
          iconClassName="text-emerald-700"
          subtitle={data?.mission?.title}
          title="Mission Completed"
        />
      </Card>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default MissionEvent;
